import styles from './chip.module.scss';
import MaterialChip from '@mui/material/Chip';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface ChipProps {
  // avatar?: any,
  // classes?: object,
  clickable?: boolean,
  color?: | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  // component?: any,
  // deleteIcon?: any,
  // disabled?: boolean,
  icon?: any,
  label?: ReactNode;
  onDelete?: (...args: any[]) => void;
  size?: 'medium' | 'small';
  sx?: any;
  variant?: 'filled' | 'outlined';
  onClick?: (...args: any[]) => void;
  className?: string;
}

export function Chip(props: ChipProps) {
  return (
    <MaterialChip
      label={props.label}
      variant={props.variant}
      onClick={props.onClick}
      onDelete={props.onDelete}
      className={props.className}
      size={props.size}
      color={props.color}
      clickable={props.clickable}
      icon={props.icon}
    />
  );
}

export default Chip;